module.exports = __webpack_public_path__ + "static/img/banner6.3b86fe48.png";